import type { ComputedRef, Ref } from 'vue'
import type { DemandeActions } from '../shared'

export const CAPP_ACTIONS = Symbol('capp-actions')

export type CappActions = {
  representantLegalDisabled: ComputedRef<boolean>
  estMemeAddresseRepresentantLegal: Ref<boolean | null>
  mineurDisabled: ComputedRef<boolean>
} & DemandeActions

